import { FuelTypography } from '@frete.com/fuel-react'
import { SmallCrownPlus } from '~assets/icons/SmallCrownPlus'
import { FuelFlex } from '@frete.com/fuel-station-react'
import { BoxPlus } from './styled'
import { useTranslator } from '~hooks'
import { InfoBoxProps } from './interfaces'

const InfoBoxPlus = ({ handleClickUpgradePlan }: InfoBoxProps) => {
  const { k, t } = useTranslator()

  return (
    <div style={{ padding: '0px 32px' }}>
      <BoxPlus>
        <FuelFlex>
          <div style={{ marginTop: '-16px' }}>
            <SmallCrownPlus />
          </div>
          <FuelTypography size="body-sm" weight="bold" spacingLeft={28}>
            {t(k.translation.PREMIUM_PLAN)}
          </FuelTypography>
        </FuelFlex>

        <FuelFlex>
          <FuelTypography size="caption" spacingTop={12} weight="medium">
            {t(k.translation.ACCESS_CATALOG_PRODUCTS)}
          </FuelTypography>

          <FuelTypography
            size="caption"
            spacingLeft={4}
            spacingTop={12}
            weight="bold"
            style={{ textDecoration: 'underline', cursor: 'pointer', height: 'fit-content' }}
            onClick={handleClickUpgradePlan}
          >
            {t(k.translation.SUBSCRIBE_NOW)}
          </FuelTypography>
        </FuelFlex>
      </BoxPlus>
    </div>
  )
}

export default InfoBoxPlus
